export enum SentimentAnalysisResult {
  POSITIVE = 'Positive',
  NEGATIVE = 'Negative',
  NEUTRAL = 'Neutral',
  OUT_OF_OFFICE = 'OutOfOffice',
}
